<list-view *ngIf="listeExercices" [liste]="listeExercices"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>